type LocalStorageKeysType = 'token' | 'tokenc' | 'eventId' | 'licenseId' | 'roleId' | 'weightUnit' | 'veritabaniId';

export const setValueWithKey = (key: LocalStorageKeysType, value: string) => {
  sessionStorage.removeItem(key);
  sessionStorage.setItem(key, value);
};

export const getValueWithKey = (key: LocalStorageKeysType) => {
  return sessionStorage.getItem(key);
};

export const removeKeyPair = (key: LocalStorageKeysType) => {
  sessionStorage.removeItem(key);
};

export const reset = () => {
  sessionStorage.clear();
};
